import { featureState, lockedPath } from '@/helpers/entitlements'

// Same shape as buildParsleyGuard: takes a user getter so it needs no store in
// tests. The router's beforeEach has loaded the user before beforeEnter runs.
export const buildFeatureGuard =
  (key, getUser, fallback = '/') =>
  () => {
    const state = featureState(getUser(), key)
    if (state === 'on') return true
    return state === 'locked' ? lockedPath(key) : fallback
  }
